import { useEffect, useState } from 'react';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';

import { ListView } from '../components/ListView';
import { loginRequest, protectedResources } from "../authConfig";
//import useFetchWithMsal from '../hooks/useFetchWithMsal';
import useFetch from '../hooks/useFetch';
import Spinner from '../components/Spinner'; // Import the Spinner component
import Spinner2 from '../components/Spinner2'; // Import the Spinner component

const TodoListContent = () => {
    const { error, execute } = useFetch({
        scopes: protectedResources.apiTodoList.scopes.read,
    });

    const [todoListData, setTodoListData] = useState(null);
    const [loading, setLoading] = useState(true); // Loading state

    useEffect(() => {
        if (!todoListData) {
            setLoading(true);
            execute("GET", protectedResources.apiTodoList.endpoint).then((response) => {
                console.log("API Response: " + response);
                setTodoListData(response);
                setLoading(false);
            }).catch((error) => {
                console.log("API Error: " + error);
            });
        }
    }, [execute, todoListData])

    if (error) {
        return (
            <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '40vh' }}>
                <div className="alert alert-danger text-center" role="alert">
                    <h4 className="alert-heading">Oops! Something went wrong.</h4>
                    <p>Error: {error.message}</p>
                    <hr />
                    <p className="mb-0">Please try again later or contact support if the problem persists.</p>
                </div>
            </div>
        );
    }

    // Render spinner if loading, else render the list
    return (
        <>
            {loading ? (
                <Spinner2 marginTop="20vh" /> // Use the Spinner component
            ) : (
                todoListData ? <ListView todoListData={todoListData} /> : null
            )}
        </>
    );

    // return <>{todoListData ? <ListView todoListData={todoListData} /> : null}</>;


};

/**
 * The `MsalAuthenticationTemplate` component will render its children if a user is authenticated
 * or attempt to sign a user in. Just provide it with the interaction type you would like to use
 * (redirect or popup) and optionally a request object to be passed to the login API, a component to display while
 * authentication is in progress or a component to display if an error occurs. For more, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
export const TodoList = () => {
    const authRequest = {
        ...loginRequest,
    };

    return (
        <MsalAuthenticationTemplate 
            interactionType={InteractionType.Redirect} 
            authenticationRequest={authRequest}
        >
            <TodoListContent />
        </MsalAuthenticationTemplate>
    );
};
